import { useEffect, useState } from 'react';
export function useOverlays(isAuthenticated: boolean) {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showAscensionSplash, setShowAscensionSplash] = useState(false);
  // 每次已登录进入 APP 时显示过渡页 2 秒后自动进入
  useEffect(() => {
    if (!isAuthenticated) {
      setShowSidebar(false);
      setShowCalendar(false);
      setShowAscensionSplash(false);
      return;
    }
    setShowAscensionSplash(true);
    const t = setTimeout(() => setShowAscensionSplash(false), 3000);
    return () => clearTimeout(t);
  }, [isAuthenticated]);

  return {
    showSidebar,
    setShowSidebar,
    showCalendar,
    setShowCalendar,
    showAscensionSplash,
    setShowAscensionSplash,
  };
}
